import { useEffect } from 'react';
import { useNFLLeague } from '@/contexts/NFLLeagueContext';
import { pingOnLeagueEntry } from '@/lib/devicePing';

// SAB item 5: fire a Soap device-ping on CONTEST ENTRY (entering a league the user is a
// member of). Keyed on currentLeague?.id, so switching tabs never fires it; once per
// league per session; sends only if a recent cached GPS fix exists (never prompts).
// Must be used inside NFLLeagueProvider. Telemetry, non-blocking.
export function useDevicePingOnLeagueEntry(): void {
  const { currentLeague } = useNFLLeague();
  const leagueId = currentLeague?.id ?? null;
  useEffect(() => {
    if (leagueId) pingOnLeagueEntry(leagueId);
  }, [leagueId]);
}
